module.exports = __webpack_public_path__ + "img/section1Bg.5f360416.jpg";